import React from 'react';

import { StyleSheet } from 'react-native';

import ActionButton, { IActionButtonProps } from 'components/action-button';
import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

type StyledActionButtonProps = Omit<IActionButtonProps, 'children'> & {
  children?: React.ReactNode;
};

export const StyledActionButton = (props: StyledActionButtonProps) =>
  React.createElement(
    Box,
    { style: styles.buttonWrapper },
    React.createElement(ActionButton, { fullWidth: true, ...props })
  );

const styles = StyleSheet.create({
  buttonWrapper: {
    marginBottom: spacing.$4,
    width: '100%',
  },
});
